import React from 'react';
import { useTranslation } from 'react-i18next';
import TextField from 'apollo-react/components/TextField';
import IconButton from 'apollo-react/components/IconButton';
import Tooltip from 'apollo-react/components/Tooltip';
import Info from 'apollo-react-icons/Info';
import Copy from 'apollo-react-icons/Copy';

function FieldLabel({ label, helpText }) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <span>{label}</span>
      {helpText && (
        <Tooltip title={helpText} placement="top">
          <span style={{ display: 'inline-flex', cursor: 'pointer' }}>
            <Info fontSize="extraSmall" style={{ color: '#595959' }} />
          </span>
        </Tooltip>
      )}
    </div>
  );
}

export default function OutputFieldRow({ field }) {
  const [t] = useTranslation();

  const handleCopy = () => {
    navigator.clipboard.writeText(field.value || '');
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <div style={{ marginBottom: 6 }}>
        <FieldLabel label={field.label} helpText={field.help_text} />
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <div style={{ flex: 1 }}>
          <TextField value={field.value || ''} disabled fullWidth />
        </div>
        <Tooltip title={t('Copy to clipboard')} placement="top">
          <span style={{ display: 'inline-flex' }}>
            <IconButton size="small" onClick={handleCopy}>
              <Copy />
            </IconButton>
          </span>
        </Tooltip>
      </div>
    </div>
  );
}
